/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "addons": {
        "nested": {
          "external": {
            "nested": {
              "AddonResponseStatus": {
                "values": {
                  "DO_NOT_USE_ADDON_RESPONSE_STATUS": 0,
                  "ACTION_TAKEN": 1,
                  "NO_OP_NO_ACTION_NEEDED": 2,
                  "NO_OP_DUPLICATE_IDEMPOTENCY_TOKEN": 3,
                  "NO_OP_REQUIREMENT_NOT_MET": 4
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.addons?.nested?.external?.nested?.AddonResponseStatus) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE AddonResponseStatus @ squareup/addons/external/addon_response_status.proto at 8:1
 */
export const AddonResponseStatus = $root.lookupEnum('squareup.addons.external.AddonResponseStatus').values;